/**
 * Vendor JS bundle - imports all third-party libraries
 * This replaces the webpack.mix.js vendor.min.js concatenation
 *
 * NOTE: Uses dynamic imports inside an IIFE for jQuery-dependent libraries
 * to ensure jQuery is globally available before they load. ES module static imports
 * are hoisted, so we must use dynamic imports for proper sequencing.
 */

// jQuery - MUST be first
import jQuery from 'jquery';

// Expose jQuery globally BEFORE any other imports
window.$ = window.jQuery = jQuery;

// WOW.js - needs window.WOW (not jQuery dependent, can be static)
import WOW from 'wow.js';
window.WOW = WOW;

// Helper to load a script in global context (bypasses ES module wrapping)
function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

// Load all jQuery-dependent libraries sequentially
async function loadVendorPlugins() {
    // Bootstrap - depends on jQuery being global
    await import('lib/bootstrap/dist/js/bootstrap.js');

    // FastClick
    await import('lib/fastclick/lib/fastclick.js');

    // jQuery Appear
    await import('lib/jquery.appear/jquery.appear.js');

    // Flickity - loaded as classic script to avoid UMD/require() conflict in ES module context
    await loadScript('/lib/flickity/dist/flickity.pkgd.js');

    // Backstretch
    await import('lib/backstretch/jquery.backstretch.js');

    // jQuery ScrollTo - loaded as classic script to avoid UMD/require() conflict
    await loadScript('/lib/jquery.scrollTo/jquery.scrollTo.js');

    // Google Maps
    await import('lib/google-maps/lib/Google.js');

    // Jarallax
    await import('lib/jarallax/dist/jarallax.min.js');
    await import('lib/jarallax/dist/jarallax-video.js');

    // Select2 - load as classic script to ensure it sees global jQuery
    await loadScript('/lib/select2/dist/js/select2.js');
}

// Export the promise for app-legacy.js to await
export const vendorScriptsReady = loadVendorPlugins();
